






































import {computed, defineComponent, onMounted, useRoute, watch} from '@nuxtjs/composition-api';
import { useCart } from '~/composables';
import cartGetters from "~/modules/checkout/getters/cartGetters";
import {usePageStore} from "~/stores/page";

export default defineComponent({
  name: "FreeShippingBar",
  data: () => ({
    showed: true,
    showInfoLabel: false,
    currentLabel: 'init_message',
  }),
  setup() {
    const {cart,load: load} = useCart();
    const route = useRoute();
    const {routeData} = usePageStore();

    const type = computed(() => routeData?.type);
    const isCart = computed(() => route.value?.matched?.length > 1 && route.value?.matched?.[0].name.indexOf('checkout/cart') > -1);
    const pageUrl = computed(() => route.value?.path);

    onMounted(async () => {
      if (!(route.value.fullPath.indexOf('customer') > -1) && !(route.value.name.indexOf('checkout') > -1)) {
        await Promise.all([
          load()
        ]);
      }
    })
    const freeShippingBar = computed(() => cartGetters.getFreeShippingBar(cart.value));
    const cartTotals = computed(() => cartGetters.getTotals(cart.value));

    function shouldShowProgressiveLabel() {
      return cartTotals.value.total > 0;
    }

    function getLabel(labelName) {
      //@ts-ignore
      if (this.cartTotals.total >= this.freeShippingBar.goal) {
        labelName = 'achieved_message';
      }
      //@ts-ignore
      let labelValue = this.freeShippingBar?.labels?.[labelName];
      if (labelValue) {
        if (labelName === 'progress_message') {
          //@ts-ignore
          const remainingGoal = Math.max(this.freeShippingBar?.goal - this.cartTotals.total, 0);
          //@ts-ignore
          labelValue = labelValue.replace('{{ruleGoalLeft}}', this.$fc(remainingGoal.toString()));
        } else if (labelName !== 'achieved_message') {
          //@ts-ignore
          labelValue = labelValue.replace('{{ruleGoal}}', this.$fc(this.freeShippingBar?.goal.toString()));
        }
      }
      return labelValue;
    }

    function checkPage() {
      if (pageUrl.value !== '/') {
        return type.value === 'SUB_CATEGORY' || type.value === 'CATEGORY' || isCart;
      }
      return false;
    }

    return {
      checkPage,
      getLabel,
      shouldShowProgressiveLabel,
      freeShippingBar,
      cartTotals
    }
  },
});
